import axios from 'axios';
import {
  LOTTERY_AVAILABLE_TABS_REQUEST,
  LOTTERY_AVAILABLE_TABS_SUCCESS,
  LOTTERY_AVAILABLE_TABS_FAILURE,
  LOTTERY_PAGE_DATA_REQUEST,
  LOTTERY_PAGE_DATA_SUCCESS,
  LOTTERY_PAGE_DATA_FAILURE,
  LOTTERY_PRIZE_DATA_REQUEST,
  LOTTERY_PRIZE_DATA_SUCCESS,
  LOTTERY_PRIZE_DATA_FAILURE,
  LOTTERY_SERIAL_DATA_REQUEST,
  LOTTERY_SERIAL_DATA_SUCCESS,
  LOTTERY_SERIAL_DATA_FAILURE,
  LOTTERY_SPECIAL_DATA_REQUEST,
  LOTTERY_SPECIAL_DATA_SUCCESS,
  LOTTERY_SPECIAL_DATA_FAILURE,
  LOTTERY_SPECIAL_DATA_RESET,
  LOTTERY_ONE_OF_SERIAL_REQUEST,
  LOTTERY_ONE_OF_SERIAL_SUCCESS,
  LOTTERY_ONE_OF_SERIAL_FAILURE,
  GET_LOTTERY_QUERY_RESULT_REQUEST,
  GET_LOTTERY_QUERY_RESULT_SUCCESS,
  GET_LOTTERY_QUERY_RESULT_FAILURE,
  GET_LOTTERY_QUERY_RESULT_RESET,
  LOTTERY_BUY_TICKETS_REQUEST,
  LOTTERY_BUY_TICKETS_SUCCESS,
  LOTTERY_BUY_TICKETS_FAILURE,
  LOTTERY_BUY_TICKETS_RESET,
  TOGGLE_TICKET_TO_LOTTERY_SLIP,
  TOGGLE_TICKET_TO_SUPER_LOTTERY_SLIP,
  CLEAR_LOTTERY_SLIP,
  CLEAR_SUPER_LOTTERY_SLIP,
  SET_LOTTERYSLIP_FROM_LOCAL_STORAGE,
  SET_SUPER_LOTTERYSLIP_FROM_LOCAL_STORAGE,
  LOTTERY_SET_RENDER_TYPE
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';
import { loadStateFromIndexedDB } from 'Utils/manageIndexedDB';
import { updateUserBalance } from 'Store/actions';
import ProjectConfig from 'ProjectConfig';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getLotteryAvailableTabs = isSuper => async dispatch => {
  try {
    dispatch({
      type: LOTTERY_AVAILABLE_TABS_REQUEST
    });

    const apiBase = isSuper ? 'super-lottery' : 'lottery';

    const res = await axios({
      url: `${API_GATEWAY}/mobile/${apiBase}/tabs`,
      method: 'get'
    });

    dispatch({
      type: LOTTERY_AVAILABLE_TABS_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: LOTTERY_AVAILABLE_TABS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getLotteryPageData = (tabType, selectedTickets = [], isSuper = false) => async dispatch => {
  try {
    dispatch({
      type: LOTTERY_PAGE_DATA_REQUEST
    });

    const apiBase = isSuper ? 'super-lottery' : 'lottery';
    let tabTypeParam = isSuper && tabType === 'QUARTER' ? 'FULL' : tabType;

    const res = await axios({
      url: `${API_GATEWAY}/mobile/${apiBase}/ticket-page?tabType=${tabTypeParam}`,
      method: 'get'
    });

    dispatch({
      type: LOTTERY_PAGE_DATA_SUCCESS,
      payload: {
        ...res.data,
        selectedTickets,
        tabType
      }
    });

  } catch (e) {

    dispatch({
      type: LOTTERY_PAGE_DATA_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getLotterySerialData = (ticketType, tabType, serialType, selectedTickets, isSuper = false) => async dispatch => {
  try {
    dispatch({
      type: LOTTERY_SERIAL_DATA_REQUEST
    });

    const apiBase = isSuper ? 'super-lottery' : 'lottery';

    const res = await axios({
      url: `${API_GATEWAY}/mobile/${apiBase}/serial-ticket?serialType=${serialType}`,
      method: 'get'
    });

    dispatch({
      type: LOTTERY_SERIAL_DATA_SUCCESS,
      payload: {
        ...res.data,
        ticketType,
        tabType,
        serialType,
        selectedTickets
      }
    });

  } catch (e) {

    dispatch({
      type: LOTTERY_SERIAL_DATA_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getLotteryOneOfSerial = (serialInfo, serialType, isSuper = false) => async dispatch => {
  try {
    dispatch({
      type: LOTTERY_ONE_OF_SERIAL_REQUEST
    });

    const { serialCode, drawNumber, ticketType } = serialInfo;
    const apiBase = isSuper ? 'super-lottery' : 'lottery';

    const res = await axios({
      url: `${API_GATEWAY}/mobile/${apiBase}/serial-ticket/${serialCode}?drawNumber=${drawNumber}&serialType=${serialType}&ticketType=${ticketType}`,
      method: 'get'
    });

    dispatch({
      type: LOTTERY_ONE_OF_SERIAL_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: LOTTERY_ONE_OF_SERIAL_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const toggleTicketToLotterySlip = (ticketData, isSuper = false) => dispatch => {
  dispatch({
    type: isSuper ? TOGGLE_TICKET_TO_SUPER_LOTTERY_SLIP : TOGGLE_TICKET_TO_LOTTERY_SLIP,
    payload: {
      ...ticketData
    }
  });
};

export const clearLotterySlip = isSuper => ({
  type: isSuper ? CLEAR_SUPER_LOTTERY_SLIP : CLEAR_LOTTERY_SLIP
});

export const getLotterySpecialData = (ticketPattern, ticketType, selectedTickets, isSuper = false) => async dispatch => {
  try {
    dispatch({
      type: LOTTERY_SPECIAL_DATA_REQUEST
    });

    const apiBase = isSuper ? 'super-lottery' : 'lottery';

    const res = await axios({
      url: `${API_GATEWAY}/mobile/${apiBase}/special-ticket?pattern=${ticketPattern}`,
      method: 'get'
    });

    dispatch({
      type: LOTTERY_SPECIAL_DATA_SUCCESS,
      payload: {
        ...res.data,
        ticketType,
        selectedTickets
      }
    });

  } catch (e) {

    dispatch({
      type: LOTTERY_SPECIAL_DATA_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const resetLotterySpecialData = () => async dispatch => {
  dispatch({
    type: LOTTERY_SPECIAL_DATA_RESET
  });
};

export const getLotteryQueryResult = (drawNumber, ticketNumber, isSuper = false) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_LOTTERY_QUERY_RESULT_REQUEST
    });

    const apiBase = isSuper ? 'super-lottery' : 'lottery';

    const requestUrl = getState().auth.isAuthenticated
      ? `${API_GATEWAY}/mobile/${apiBase}/draw/${drawNumber}/ticket/${ticketNumber}/result`
      : `${API_GATEWAY}/mobile/${apiBase}/public/draw/${drawNumber}/ticket/${ticketNumber}/result`;

    const res = await axios({
      url: requestUrl,
      method: 'get'
    });

    dispatch({
      type: GET_LOTTERY_QUERY_RESULT_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: GET_LOTTERY_QUERY_RESULT_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const resetLotteryQueryResult = () => ({
  type: GET_LOTTERY_QUERY_RESULT_RESET
});

export const buyTickets = isSuper => async (dispatch, getState) => {
  try {
    dispatch({
      type: LOTTERY_BUY_TICKETS_REQUEST
    });

    const buyObject = isSuper ? getState().lottery.superLotterySlipData.buy : getState().lottery.lotterySlipData.buy;
    const apiBase = isSuper ? 'super-lottery' : 'lottery';

    const res = await axios({
      url: `${API_GATEWAY}/mobile/${apiBase}/ticket/purchase`,
      method: 'post',
      data: buyObject
    });

    dispatch({
      type: LOTTERY_BUY_TICKETS_SUCCESS,
      payload: {
        ...res.data
      }
    });

    dispatch(updateUserBalance());
  } catch (e) {

    dispatch({
      type: LOTTERY_BUY_TICKETS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const buyTicketsReset = () => ({
  type: LOTTERY_BUY_TICKETS_RESET
});

export const getLotteryPrizes = isSuper => async dispatch => {
  try {
    dispatch({
      type: LOTTERY_PRIZE_DATA_REQUEST
    });

    const apiBase = isSuper ? 'super-lottery' : 'lottery';

    const res = await axios({
      url: `${API_GATEWAY}/mobile/${apiBase}/prize`,
      method: 'get'
    });

    dispatch({
      type: LOTTERY_PRIZE_DATA_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: LOTTERY_PRIZE_DATA_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const setLotteryslipFromLocalStorage = () => dispatch => {
  loadStateFromIndexedDB('lotterySlip', data => {
    dispatch({
      type: SET_LOTTERYSLIP_FROM_LOCAL_STORAGE,
      payload: data
    });
  });
};

export const setSuperLotteryslipFromLocalStorage = () => dispatch => {
  loadStateFromIndexedDB('superLotterySlip', data => {
    dispatch({
      type: SET_SUPER_LOTTERYSLIP_FROM_LOCAL_STORAGE,
      payload: data
    });
  });
};

export const setLotteryRenderType = () => dispatch => {
  dispatch({
    type: LOTTERY_SET_RENDER_TYPE
  });
};
